<template>
    <div :class="`game-navigation-wrapper ${activeGameNameClass}`">
        <b-nav class="game-navigation" pills ref="scrollArea">
            <b-nav-item :class="{'control d-flex justify-content-center left d-md-none':true, 'inactive':leftIsNotScrollable, 'd-none': elementIsNotScrollable}" @click="scroll(-1)">
                <div class="d-flex align-items-center"><fa-icon icon="chevron-left"></fa-icon></div>
            </b-nav-item>
            <b-nav-item class="go-home" v-if = "homeLink" @click="goHome">
                <div class="d-flex justify-content-center align-items-center">
                    <span class="home-icon">
                    </span>
                </div>
            </b-nav-item>
            <b-nav-item v-for="game in games"
                :key="game.id" @click="setGame(game.id)"
                v-if="game.version === 2"
                :to="{ name: 'lottery', params: { gameId: game.id } }"
                link-classes="p-2 d-flex align-items-center d-md-block justify-content-center"
                exact
                :class="{'active':$route.matched.some(({ name }) => name === 'lottery') && $route.params.gameId === game.id}">
                <div class="d-flex justify-content-between flex-column flex-md-row align-items-center">
                    <span>{{ game.name | lang('titles') }}</span>
                    <span v-if="timeIsOver(game.id)">
                        <template v-if="showLiveIndicator(game.id)">
                            <b-spinner small type="grow" variant="danger"></b-spinner>
                            <span class="text-light align-self-center text-uppercase live">{{ 'live' | lang }}</span>
                        </template>
                    </span>
                    <countdown v-else-if="secondsLeft(game.id)" class="text-light" :seconds-left="secondsLeft(game.id)"></countdown>
                </div>
            </b-nav-item>
            <b-nav-item :class="{'control right d-flex justify-content-center d-md-none':true, 'inactive':rightIsNotScrollable, 'd-none': elementIsNotScrollable}" @click="scroll(1)">
                <div class="d-flex align-items-center"><fa-icon icon="chevron-right"></fa-icon></div>
            </b-nav-item>
        </b-nav>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import Countdown from '@tv/components/partials/Countdown';
import { createMixin } from '@tv/mixins/scroll';
const moment = require('moment');

export default {
    mixins: [ createMixin() ],
    components: { Countdown },
    data() {
        return {
            scrollStep: 150,
            reference: 'scrollArea',
            homeLink: Config.home_url
        }
    },

    computed: {
        ...mapState(['purchaseGameId', 'allDraws']),

        games() {
            return Config.games;
        },

        activeGameNameClass() {
            const name = this.$route.params.gameId ? 'active-game-' + Config.games[this.$route.params.gameId].name : '';

            return name;
        },
    },

    methods: {
        ...mapMutations(['setPurchaseGameId']),
        setGame(id) {
            this.setPurchaseGameId(id);
        },

        showLiveIndicator(gameId) {
            return !this.games[gameId].studio_static_video;
        },

        secondsLeft(gameId) {
            const channelId = Config.games[gameId].channel_id;
            return this.$store.getters.remaining(channelId);
        },
        timeIsOver(game_id) {
            const studioId = parseInt(Config.games[game_id].tv_studios_id);
            const maxDuration = Config.games[game_id].studio_max_duration;
            let activeStream = false;

            for (const draw of Object.values(this.allDraws)) {
              if (draw.tv_studios_id == studioId) {
                const dt = moment.utc(draw.datetime);

                if (moment.utc().format('YYYY-MM-DD HH:mm:ss') >= dt.format('YYYY-MM-DD HH:mm:ss')) {
                  if (moment.utc(draw.datetime).add(maxDuration, 'seconds').format('YYYY-MM-DD HH:mm:ss') >= moment.utc().format('YYYY-MM-DD HH:mm:ss')) {
                    activeStream = true;
                  }
                }
              }
            }

            return this.secondsLeft(game_id) <= 0 || activeStream;
        },
        goHome() {
            if (window.parent) {
                window.open(this.homeLink, '_top');
            } else {
                window.location = this.homeLink;
            }
        }
    },
    watch: {
        purchaseGameId(val) {
            this.$nextTick(() => {
                this.selectedItemToCenter();
            });
        }
    },
}
</script>
